import React from 'react';

// A grey bar standing in for text, a number or a picture that hasn't loaded.
// Skeletons draw these inside the real component's markup (Bone.scss).
export default function Bone({ width, height = 12, round = false }) {
	const className = `skeleton-bone${round ? ' skeleton-bone--round' : ''}`;
	return <span className={className} style={{ width, height }} />;
}
